define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var core = require('core');
    var user = require('user');
    var config = require('config');
    var device = require('util/device.util');
    var url = require('util/url.util');
    var storage = require('util/storage.util');

    var BaseReplacerView = require('common/base.replacer.view');
    var StickyFooterModelInstance = require(
        'replacers/totalcasino-theme/sticky-footer/base.sticky-footer.model.instance');
    var SliderClass = require('class/totalcasino-theme/slider.class');

    var replacers = {
        favorites: require('replacers/totalcasino-theme/favorites/favorites.view'),
        hot: require('replacers/totalcasino-theme/hot/hot.view'),
        recent: require('replacers/totalcasino-theme/recent/recent.view')
    };

    require('widgets/totalcasino-theme/scrollSpy.widget');

    module.exports = BaseReplacerView.extend({

        model: StickyFooterModelInstance,

        events: {
            'tap .fn-sticky-footer__header': 'handleTabTap',
            'tap .fn-close-btn': 'closeFooterTab',
            'tap .fn-login-button': 'redirectToLogin'
        },

        subscribe: function() {
            this.listenTo(core, {
                'footer-games:loaded': this.addSlider,
                'gamesViewMode:changed': this.afterRender,
                'navigate': this.updateSliderWidth
            });
        },

        redirectToLogin: function(e) {
            e.preventDefault();
            e.stopPropagation();

            /* TotalCasino changes */
            const { pathname, search } = window.location;
            const newBackURLWithSearch = `${pathname}${search}`;

            if (config.get('loginPage')) {
                storage.session.setItem('backPageUrl', url.getCleanUrl(newBackURLWithSearch));
            }

            core.trigger('app:message', {
                ID: 'showLogin',
                data: {
                    afterLoginUrl: newBackURLWithSearch
                }
            });
            /* TotalCasino changes */
        },

        initialize: function() {
            BaseReplacerView.prototype.initialize.apply(this, arguments);
            this.gameWidth = config.get('footerGameWidthInPixels') || 140;
        },

        render: function() {
            var previousActiveReplacer;
            var currentReplacer;
            var activeTab;
            var isUserLoggedIn = user.isLogin();

            previousActiveReplacer = this.model.get('activePage') || '';
            currentReplacer = previousActiveReplacer ? replacers[previousActiveReplacer].nameOfReplacers : '';

            this.$el.html(this.tmpl('base.sticky-footer', {
                isUserLoggedIn: isUserLoggedIn,
                isDesktop: device.formFactor === 'desktop',
                registrationPageUrl: config.get('registrationURL'),
                promotionsPageUrl: config.get('promotionsPageURL'),
                cashierPageUrl: config.get('cashiersPages.deposit')
            }));

            if (currentReplacer.length > 0) {
                activeTab = this.$el.find('.' + previousActiveReplacer)[0];
                previousActiveReplacer === 'recent' && !isUserLoggedIn ?
                    this.closeFooterTab() :
                    this.openFooterTab(currentReplacer, activeTab, previousActiveReplacer);
            }

            this.afterRender();
            return this;
        },

        afterRender: function() {
            this.updateSliderWidth();

            if (device.formFactor === 'desktop') {
                var $accordion = $('.fn-accordion');
                $accordion.on('expand', this.addScrollSpyWidget.bind(this));
                $accordion.on('collapse', this.addScrollSpyWidget.bind(this));

                this.addScrollSpyWidget();
            } else {
                this.$el.find('.fn-sticky-footer').addClass('scrollSpy-fixed');
            }
        },

        addScrollSpyWidget: function() {
            var $stickyFooter = this.$el.find('.fn-sticky-footer');
            var $footerBottomPart = $('.fn-footer');
            $footerBottomPart.addClass('fn-footer-bottom-part');

            if ($footerBottomPart.length && !$footerBottomPart.isInViewport()) {
                $stickyFooter.addClass('scrollSpy-fixed');
            } else {
                $stickyFooter.hasClass('scrollSpy-fixed') && $stickyFooter.removeClass('scrollSpy-fixed');
            }

            this.$el.scrollSpy({
                fixedElement: $stickyFooter,
                elementWrapper: $('.fn-sticky-footer__wrapper, .fn-footer-wrapper'),
                breakpoint: this.calculateBreakpoint(),
                checkFunc: this.calculateBreakpoint
            });
        },

        calculateBreakpoint: function() {
            var footerBottomPartEl = $('.fn-footer-bottom-part')[0];
            return footerBottomPartEl ? footerBottomPartEl.getBoundingClientRect().top : 0;
        },

        handleTabTap: function(e) {
            var previousActiveTab = this.$el.find('.fn-sticky-footer__tab.active')[0];
            var targetTab = e.target.closest('.fn-sticky-footer__tab');
            var activeTabName = targetTab ? targetTab.dataset.name : '';

            var shouldPreventAction = _.isNull(targetTab);
            if (shouldPreventAction) {
                return;
            }

            var tapToCloseFooter = previousActiveTab === targetTab
                || !targetTab && $('.fn-footer-wrapper').hasClass('open');
            if (tapToCloseFooter) {
                this.closeFooterTab();
                return;
            }

            var activeReplacerView = replacers[activeTabName];
            activeReplacerView && this.openFooterTab(activeReplacerView.nameOfReplacers, targetTab, activeTabName);

            this.afterRender();
        },

        openFooterTab: function(currentReplacer, targetTab, activeReplacerName) {
            this.model.set('activePage', activeReplacerName);
            this.setActiveTab(targetTab);

            $('.fn-footer-wrapper').addClass('open');

            this.$('.fn-sticky-footer__main').html(this.tmpl('base.sticky-footer.main', {
                replacer: currentReplacer
            }).replace());
        },

        setActiveTab: function(targetTab) {
            var previousActiveTab = this.$el.find('.fn-sticky-footer__tab.active');

            previousActiveTab.length > 0 && previousActiveTab.removeClass('active');
            $(targetTab).hasClass('fn-sticky-footer__tab') && $(targetTab).addClass('active');
        },

        closeFooterTab: function() {
            $('.fn-footer-wrapper').removeClass('open');
            this.$('.fn-sticky-footer__tab.active').removeClass('active');
            this.$('.fn-sticky-footer__main')[0].children[0].remove();
            this.model.set('activePage', '');

            this.slider && this.slider.close();
            this.afterRender();
        },

        addSlider: function($replacer) {
            var $games = $replacer.find('.fn-launch-game');

            if (device.formFactor === 'desktop' && this.isSliderActive($games.length, $replacer)) {
                this.renderSlider($games.length, $replacer);
            }
        },

        isSliderActive: function(gamesLength) {
            var $stickyFooterMain = $('.fn-sticky-footer__main');
            var paddingLeft = parseInt($stickyFooterMain.css('padding-left'));
            var paddingRight = parseInt($stickyFooterMain.css('padding-right'));

            var widthOfContainer = $stickyFooterMain[0]
                ? $stickyFooterMain[0].offsetWidth - paddingLeft - paddingRight
                : 0;
            var widthOfItems = this.gameWidth * gamesLength;

            return $('.fn-footer-wrapper').hasClass('open')
                && this.$el.find('.fn-slider') && widthOfItems > widthOfContainer;
        },

        renderSlider: function(itemsNumber, mainEl) {
            this.slider = new SliderClass(mainEl.find('.fn-slider'), mainEl, {
                itemWidth: this.gameWidth,
                itemsCount: itemsNumber,
                throttleValue: 50,
                $scrollLeft: mainEl.find('.fn-previous') || $('.fn-previous'),
                $scrollRight: mainEl.find('.fn-next') || $('.fn-next')
            });
        },

        updateSliderWidth: function() {
            this.slider && this.slider.updateSliderWidth();
        }

    }, {
        nameOfReplacers: [
            'STICKY_FOOTER'
        ]
    });
});
